import { Pipe, PipeTransform } from '@angular/core';
import { clone } from 'lodash-es';

@Pipe({
  name: 'clone',
  standalone: true,
})
export class ClonePipe implements PipeTransform {
  transform(value: unknown): unknown {
    return clone(value);
  }
}
